import {
  Center,
  Flex,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react'

import { Button } from '@/components/ui'

import { GridModalHeader } from '../../components/GridModalHeader'
import { IncidentOptionI } from '../../types/types'

interface GridTestErrorCardIProps {
  isTimeout: boolean
  onClose: () => void
  onSelectAnotherIncident: () => void
  onRetry?: () => void
  selectedIncident: IncidentOptionI | null
}

export const GridTestErrorCard = ({
  isTimeout,
  onClose,
  onSelectAnotherIncident,
  onRetry,
  selectedIncident,
}: GridTestErrorCardIProps) => (
  <>
    <ModalHeader p={0} w='100%'>
      <GridModalHeader
        subtitle={
          selectedIncident
            ? `Results for ${selectedIncident.incidentId}`
            : 'Grid Testing Zone'
        }
        title={isTimeout ? 'Test Timed Out' : 'Test Failed'}
      />
    </ModalHeader>
    <ModalBody p={0}>
      <Center flexDirection='column' minH='300px' textAlign='center'>
        <Text color='red.600' fontSize='lg' fontWeight='bold' mb={2}>
          {isTimeout ? 'The operation timed out' : 'Something went wrong'}
        </Text>
        <Text color='gray.600' fontSize='sm' maxW='400px'>
          {isTimeout
            ? 'The operation timed out. Please try again later.'
            : 'The grid analysis job could not be completed. Please try again.'}
        </Text>
      </Center>
    </ModalBody>
    <ModalFooter mt={6} p={0}>
      <Flex direction='row' gap={3} justifyContent='flex-end'>
        <Button mr={0} onClick={onClose} variant='secondary'>
          Cancel
        </Button>
        <Button mr={0} onClick={onSelectAnotherIncident} variant='secondary'>
          Select Another Incident
        </Button>
        {onRetry && <Button onClick={onRetry}>Retry</Button>}
      </Flex>
    </ModalFooter>
  </>
)
